import React from 'react';
import { cn } from '@/lib/utils';
import SearchBar from '@/components/search/SearchBar';

interface HeroSectionProps {
  backgroundImages?: string[];
  showSearch?: boolean;
  searchProps?: {
    variant?: 'hero' | 'page' | 'compact';
    showTabs?: boolean;
    onSearch?: (filters: any) => void;
  };
  className?: string;
}

const HeroSection: React.FC<HeroSectionProps> = ({
  backgroundImages = ["/banner-casa-1.png"],
  showSearch = true,
  searchProps = {
    variant: "hero",
    showTabs: true,
    onSearch: (filters) => console.log("Hero search filters:", filters),
  },
  className,
}) => {
  const patternImage = backgroundImages[0];

  return (
    <section className={cn("relative w-full", className)}>
      {/* Hero Background Banner with Pattern */}
      <div
        className="flex items-center w-full h-[280px] sm:h-[320px] md:h-[360px] lg:h-[400px] xl:h-[440px] relative overflow-hidden"
        style={{
          backgroundImage: `url(${patternImage})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        {/* Overlay escurecido mais suave */}
        <div className="absolute inset-0 bg-black/30" />

        <div className="relative z-10 w-full h-full flex items-center justify-center">
         
        </div>
      </div>

      {showSearch && (
        <div className="relative -mt-20 sm:-mt-24 md:-mt-28 lg:-mt-32 z-10 pb-6 sm:pb-8">
          <SearchBar
            variant={searchProps.variant}
            showTabs={searchProps.showTabs}
            onSearch={searchProps.onSearch}
          />
        </div>
      )}
    </section>
  );
};

export { HeroSection, type HeroSectionProps };
export default HeroSection;